import styled from 'styled-components';
import { crTheme } from '@comicrelief/component-library';

const borderRadius = '1rem';

const SliderWrapper = styled.div`
  margin-top: 2.2rem;
`;

const SliderBackground = styled.div`
  height: 3px;
  background: ${crTheme.color('grey_medium')};
  border-radius: ${borderRadius};
`;

const SliderProgress = styled.div.withConfig({
  shouldForwardProp: prop => prop !== 'sliderRatio', // Prevent passing sliderRatio, otherwise console error
})<{ sliderRatio: number }>`
  margin-top: -6px;
  width: ${({ sliderRatio }) => `${sliderRatio}%`};
  height: 9px;
  background: ${crTheme.color('red')};
  border-radius: ${borderRadius};
`;

interface StepSliderProps {
  currentStep: number;
  totalSteps: number;
}

export default function StepSlider({ currentStep, totalSteps }: StepSliderProps) {
  const stepPercentage = (currentStep / totalSteps) * 100;
  // check for last step, otherwise step ratio + little extra to persuade user that journey is almost finished
  const sliderRatio = currentStep >= totalSteps
    ? 100
    : stepPercentage + 10;

  return (
    <SliderWrapper>
      <SliderBackground />
      <SliderProgress sliderRatio={sliderRatio} />
    </SliderWrapper>
  );
}
